module.exports = __webpack_public_path__ + "static/media/logo.20213335.png";